import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../../services/connection-service';
import { WindowRefService } from '../../../services/window-ref-service';

@Component({
    selector: 'warehouse',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class WareHouseComponent {}
